/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_TitleInputs */

const es_admin_company_overview_title = /** @type {(inputs: Admin_Company_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información general`)
};

const en_admin_company_overview_title = /** @type {(inputs: Admin_Company_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General information`)
};

/**
* | output |
* | --- |
* | "General information" |
*
* @param {Admin_Company_Overview_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_title = /** @type {((inputs?: Admin_Company_Overview_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_title(inputs)
	return en_admin_company_overview_title(inputs)
});
export { admin_company_overview_title as "admin.company_overview.title" }